import { GET_WHITELIST, GET_WHITELIST_SEARCH, RESET_WHITELIST_SEARCH } from '../../types'

const initialState = {
  whitelist: {},
  searchResults: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_WHITELIST: return {
      ...state,
      whitelist: action.payload
    }
    case GET_WHITELIST_SEARCH: return {
      ...state,
      searchResults: action.payload
    }
    case RESET_WHITELIST_SEARCH: return {
      ...state,
      searchResults: action.payload
    }
    default: return { ...state }
  }
}
